import { ActionTypes, Actions } from '../actions/static-hosts.action';
import { StaticHostsConfiguration } from '../models/static-hosts.model';

export const initialState: StaticHostsConfiguration = {
  id: 0,
  device_id: 0,
  static_hosts: [],
  current_version: 0,
  current_active_version: 0,
  is_updates_available: false,
  updates_available_from: '',
  updates_synced_at: '',
  is_configuration_file_generated: false,
  created_at: '',
  updated_at: '',
};

export function staticHostsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case ActionTypes.SET_STATIC_HOSTS_CONFIGURATION:
      return {
        ...state,
        ...action.payload,
      };

    case ActionTypes.ADD_STATIC_HOST_CONFIGURATION:
      return {
        ...state,
        static_hosts: [...state.static_hosts, action.payload],
      };

    case ActionTypes.UPDATE_STATIC_HOST_CONFIGURATION:
      return {
        ...state,
        static_hosts: state.static_hosts.map((staticHost) =>
          staticHost.id === action.payload.id ? { ...staticHost, ...action.payload } : staticHost
        ),
      };

    case ActionTypes.DELETE_STATIC_HOST_CONFIGURATION:
      return {
        ...state,
        static_hosts: state.static_hosts.filter(
          (staticHost) => !action.payload.includes(staticHost.id)
        ),
      };

    case ActionTypes.CLEAR_STATIC_HOST_CONFIGURATION:
      return {
        ...state,
        static_hosts: [],
      };

    default:
      return state;
  }
}
